import {NgModule} from '@angular/core';
import {SharedModule} from '../shared/shared.module';
import {NotificationsComponent} from './notifications/notifications.component';
import {NotificationsService} from './notifications/notifications.service';
import {WorkingTimeService} from './notifications/working-time.service';
import {OnCallNotificationComponent} from './notifications/on-call-notification/on-call-notification.component';
import {WorkingTimeNotificationComponent} from './notifications/working-time-notification/working-time-notification.component';
import {MissingWorkingDaysNotificationComponent} from './notifications/missing-working-days/missing-working-days.component';
import {DaysOffRequestsNotificationComponent} from './notifications/days-off-requests/days-off-requests.component';
import {UnapprovedDaysOffRequestsNotificationComponent} from './notifications/unapproved-days-off-requests/unapproved-days-off-requests.component';
import {UnapprovedTimecardsNotificationComponent} from './notifications/unapproved-timecards/unapproved-timecards.component';
import {
	EmployeeUnsubmittedTimecardNotificationComponent
} from './notifications/employee-unsubmitted-timecard-notification/employee-unsubmitted-timecard-notification.component';
import {PersonalDailyReportComponent} from './personal-daily-report/personal-daily-report.component';



@NgModule({
	imports: [
		SharedModule
	],
	declarations: [
		NotificationsComponent,
		OnCallNotificationComponent,
		DaysOffRequestsNotificationComponent,
		WorkingTimeNotificationComponent,
		UnapprovedDaysOffRequestsNotificationComponent,
		MissingWorkingDaysNotificationComponent,
		UnapprovedTimecardsNotificationComponent,
		EmployeeUnsubmittedTimecardNotificationComponent,
		PersonalDailyReportComponent
	],
	exports: [NotificationsComponent],
	providers: [
		NotificationsService,
		WorkingTimeService
	],
	entryComponents: [
		NotificationsComponent,
		PersonalDailyReportComponent
	]
})
export class MyTimeModule {}



// WEBPACK FOOTER //
// ./src/app/my-time/my-time.module.ts